<template>
  <tbody>
    <template v-if="totalRows > 0">
      <tr v-for="row in insights" :key="`${metric}:${row.label}`">
        <td class="border px-4 py-2">
          {{ row.label }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.F || '' }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.M || '' }}
        </td>
        <td class="border px-4 py-2 text-right">
          {{ row.value.U || '' }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateAgeRangeSum(row.value) }}
        </td>
      </tr>
      <tr>
        <td class="border px-4 py-2 font-bold">Total</td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('F') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('M') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateGenderSum('U') }}
        </td>
        <td class="border px-4 py-2 text-right font-bold">
          {{ calculateAgeRangeGenderSum() }}
        </td>
      </tr>
    </template>
    <template v-else>
      <tr>
        <td class="border px-4 py-2 text-teal-900 text-center" colspan="3">
          No insights available.
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import { sum, sumBy } from 'lodash-es';

export default {
  props: {
    metric: {
      type: String,
      required: true,
    },
    insights: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalRows() {
      return this.insights.length;
    },
  },
  methods: {
    calculateAgeRangeSum(values) {
      return sum(Object.values(values));
    },
    calculateGenderSum(gender) {
      return sumBy(this.insights, (o) => o.value[gender]);
    },
    calculateAgeRangeGenderSum() {
      return ['M', 'F', 'U'].reduce((carry, gender) => carry + this.calculateGenderSum(gender), 0);
    },
  },
};
</script>
